module.exports = __webpack_public_path__ + "img/Banner_dashboard2.b399524f.svg";